import { PaymentEnum } from './PaymentEnum'

const PaymentStatusOption: any[] = [
  {
    value: PaymentEnum.PaymentStatus.Pending,
    label: 'Pending'
  },
  {
    value: PaymentEnum.PaymentStatus.Settled,
    label: 'Success'
  },
  {
    value: PaymentEnum.PaymentStatus.Cancelled,
    label: 'Cancelled'
  },
  {
    value: PaymentEnum.PaymentStatus.Failed,
    label: 'Failed'
  }
]
export const PaymentEnumOption = { PaymentStatusOption }
